<template>
  <div class="container-binnacle">
    <app-timeline>
      <app-timeline-item
        v-for="binnacle in binnacleUser"
        :key="binnacle.bitacoraId"
        icon="InfoIcon"
        :variant="getSeverity(binnacle.severidad)"
      >
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <h6>{{ binnacle.usuarioNombre }}</h6>
          <small class="text-muted">
            {{ binnacle.fecha | dateCompleteFormat }}
          </small>
        </div>
        <div
          class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
        >
          <p>{{ binnacle.mensaje }}</p>
          <div class="mb-1 mb-sm-0">
            <div>
              <b-avatar
                v-if="binnacle.tipoVista == -1 || binnacle.tipoVista == 0"
                v-b-tooltip.hover title="Registro Visible solo para Admin"
                text="O"
                class="mr-50"
                size="24"
                icon="eye-slash-fill"
                variant="secondary"
              />
              <b-avatar
                v-if="binnacle.correoId"
                v-b-tooltip.hover title="Ver traza de correo"
                text="O"
                class="mr-50"
                size="24"
                icon="send"
                variant="warning"
                @click.native="viewCorreoTrace(binnacle.correoId)"
              >
                <feather-icon
                  size="21"
                  icon="send"
                />
              </b-avatar>
              <b-avatar
                v-has-permission="'FEB99'"
                v-b-tooltip.hover
                title="Copiar Seguimiento"
                text="S"
                class="mr-50 add-code"
                size="24"
                icon="bug"
                variant="success"
                @click.native="copyToClipboard(binnacle.seguimientoId)"
              />
            </div>
          </div>
        </div>
      </app-timeline-item>
    </app-timeline>
    <ModalTrace ref="modalTrace" />
  </div>
</template>
<script>
import AppTimeline from '@core/components/app-timeline/AppTimeline';
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import ModalTrace from '@/febos/global/emails/components/shared/ModalTrace';

export default {
  name: 'BinnacleUser',
  mixins: [CopyToClipboard],
  components: {
    AppTimeline,
    AppTimelineItem,
    ModalTrace
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    binnacleUser: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    viewCorreoTrace(emailId) {
      this.$refs.modalTrace.open(emailId);
    },
    getSeverity(severity) {
      switch (severity) {
        case 1:
          return 'info';
        case 2:
          return 'warning';
        case 3:
          return 'danger';
        default:
          return 'secondary';
      }
    }
  }
};
</script>
<style scoped>
.container-binnacle {
  height: 500px;
  overflow-y: scroll;
}

</style>
